import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { TOMOS } from '../data/content';
export function Tomos() {
  return <section id="tomos" className="w-full bg-sand py-20 sm:py-24" data-id="element-239" data-mp="139uy6h7xsb95">
      <div className="mx-auto max-w-6xl px-5" data-id="element-240" data-mp="1h3vy3eamk4b3">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-241" data-mp="1ccdwco0s1zp2">
          <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-242" data-mp="1cat1syegqgr7">
            Los 7 Tomos
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-243" data-mp="1r33cm4t3i4zs">
            Todo el conocimiento estructurado que necesitás
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-244" data-mp="200ni5pxzqng7">
            Para enseñar con más seguridad, claridad y profesionalismo durante todo el año.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-245" data-mp="5oyvt2pfjils">
          {TOMOS.map((tomo, i) => <Reveal key={tomo.number} delay={i % 2 * 0.08} className="flex flex-col rounded-2xl border border-sand bg-cream p-7 shadow-sm transition-shadow hover:shadow-md" data-id="element-246" data-mp="1ndqq3j508m5" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-247" data-mp="39q2qilsv6ekm">
                <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-xl bg-sage-deep font-serif text-2xl font-semibold text-cream" data-id="element-248" data-mp="3eomd8ofa7ue1">
                  {tomo.number}
                </span>
                <div data-id="element-249" data-mp="3odxke5ilyoza">
                  <span className="text-xs font-semibold uppercase tracking-widest text-sage" data-id="element-250" data-mp="3oefr5w2wcllg">
                    Tomo {tomo.number}
                  </span>
                  <h3 className="font-serif text-xl font-semibold leading-tight text-ink" data-id="element-251" data-mp="19q4xqtze96y">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="mt-4 text-sm leading-relaxed text-muted" data-id="element-252" data-mp="231w3qg9t7c3q">{tomo.intro}</p>

              <ul className="mt-5 space-y-2.5" data-id="element-253" data-mp="2807fiwjnzwol">
                {tomo.points.map(point => <li key={point} className="flex items-start gap-2.5 text-sm text-ink/85" data-id="element-254" data-mp="1zzrkk8ckh7xc">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-sage" data-id="element-255" data-mp="1vy64ke4qkdix" />
                    <span data-id="element-256" data-mp="1w090feskl0vk">{point}</span>
                  </li>)}
              </ul>
            </Reveal>)}
        </div>
      </div>
    </section>;
}